import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-sanction',
  templateUrl: './loan-sanction.component.html',
  styleUrls: ['./loan-sanction.component.css']
})
export class LoanSanctionComponent implements OnInit {
  title = "LoanSanction";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/loan-sanction/loan-sanction.component.ts